import { useApi } from '@/api';
import { useParams } from 'react-router';
import EventsTable from './EventsTable';
import {
  Flex,
  Heading,
  useTableProps,
  formatDatetime,
  NetworkIcon
} from '@blockanalitica/ui';
import { Page, PageSkeleton } from '@/components';

import { useSearchParams } from '@/hooks';

export default function MarketActivityPage() {
  const [date] = useSearchParams('date', '');
  const { network } = useParams() as {
    network: string;
  };

  const { pagination, sorting } = useTableProps({
    pageSize: 20,
    initialSorting: '-order_index',
    filtersDebounceTime: 50,
    initialFilters: {
      selectedOption: ''
    }
  });

  const [data, error] = useApi({
    url: `/sparkstar/sll/psm3s/${network}/events/`
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <PageSkeleton />;
  }

  const fromDate = date ? ` on ${formatDatetime(date)}` : '';

  return (
    <Page
      title={
        <Heading size="1">
          <Flex
            flexBasis="100%"
            gap={['xs', '2xs']}
            flexDirection={['column', 'row']}>
            <NetworkIcon network={network} size="3" />
            PSM 3 Swap Activity {fromDate}
          </Flex>
        </Heading>
      }>
      <EventsTable
        pagination={pagination}
        sorting={sorting}
        network={network}
        date={date}
      />
    </Page>
  );
}
